import { Form } from 'antd';
import React from 'react';

import { UserSelect } from '../index';

export interface IFieldUser<T> {
    disabled?: boolean;
    required?: boolean;
    name?: keyof T;
    label?: string;
    mode?: 'multiple';
    onlyForProject?: string[];
}

const FieldUser = React.forwardRef(
    <T extends Record<string, any>>(
        { disabled, name, label, mode, onlyForProject }: IFieldUser<T>,
        ref: React.Ref<any>,
    ) => {
        return (
            <Form.Item<T> label={label} name={name as any}>
                <UserSelect disabled={disabled} mode={mode} ref={ref} onlyForProject={onlyForProject} />
            </Form.Item>
        );
    },
) as <T extends Record<string, any>>(props: IFieldUser<T> & { ref?: React.Ref<any> }) => React.JSX.Element;

export default FieldUser;
